import { useMemo } from "react";

import { useKpiSnapshot } from "@/api/kpi";
import { EmptyState } from "@/components/EmptyState";
import { SortableTable } from "@/components/SortableTable";
import { getSeviyeKartColumns } from "@/features/stok/columns";
import { filterSeviyeKartlar, parseStokSeviye } from "@/features/stok/seviye";
import { t } from "@/i18n";
import { fmtInt } from "@/lib/utils";

/**
 * "Seviye" sekmesi — eski arayuzle esitlik (gorev B): eski `/api/snapshot`
 * `kritik_stok.subitems` gorunumunun (legacy/js/stok.js `renderStokSeviye`)
 * geri getirilmis hali. STOK MIKTARI bazli 3 bolum (tamamen tukenmis /
 * bedeni eksik / azalan) — satis HIZI bazli "Kritik"/"Yaklaşan"
 * sekmelerinden BAGIMSIZDIR, onlar /stok/analiz kategorilerinden degismeden
 * kalir (bkz. pages/Stok.tsx). Kaynak: useKpiSnapshot ->
 * kpis.kritik_stok.subitems (bkz. features/stok/seviye.ts JSDoc — bilinen
 * admin_link eksikligi orada belgelendi).
 */
export function StokSeviye({ q }: { q: string }) {
  const snapshotQuery = useKpiSnapshot();
  const columns = useMemo(() => getSeviyeKartColumns(), []);

  if (snapshotQuery.isLoading) {
    return <p className="text-sm text-muted">{t("common.loading")}</p>;
  }
  if (snapshotQuery.isError) {
    return (
      <p role="alert" className="text-sm text-red">
        {t("common.error")}
      </p>
    );
  }

  const result = parseStokSeviye(snapshotQuery.data);
  if (result.status === "empty") {
    return <EmptyState kind="no_data" />;
  }
  if (result.status === "error") {
    return (
      <p role="alert" className="text-sm text-red">
        {t("common.error")}
      </p>
    );
  }

  return (
    <div className="space-y-6">
      <p className="text-sm text-muted">{t("stok.seviye.aciklama")}</p>
      {result.bolumler.map((bolum) => {
        const kartlar = filterSeviyeKartlar(bolum.kartlar, q);
        return (
          <section key={bolum.key}>
            <h3 className="mb-2 text-sm font-semibold text-ink">
              {t(bolum.titleKey)} <span className="font-normal text-muted">— {fmtInt(kartlar.length)}</span>
            </h3>
            {kartlar.length === 0 ? (
              <p className="text-sm text-muted">{t("stok.seviye.bolum_bos")}</p>
            ) : (
              <SortableTable columns={columns} rows={kartlar} rowKey={(k) => k.product_card_id} stickyFirstColumn />
            )}
          </section>
        );
      })}
    </div>
  );
}
